'use client';

import { ReactNode, useEffect, useState } from 'react';
import { AppProvider as PolarisAppProvider } from '@shopify/polaris';
import '@shopify/polaris/build/esm/styles.css';
import { useAppBridge } from '@shopify/app-bridge-react';
import { shortLangCode } from '@/lib/i18n';

import enTranslations from '@shopify/polaris/locales/en.json';
import frTranslations from '@shopify/polaris/locales/fr.json';
import deTranslations from '@shopify/polaris/locales/de.json';
import jaTranslations from '@shopify/polaris/locales/ja.json';
import esTranslations from '@shopify/polaris/locales/es.json';
// import idTranslations from '@shopify/polaris/locales/id.json';
import itTranslations from '@shopify/polaris/locales/it.json';
import nlTranslations from '@shopify/polaris/locales/nl.json';
import ptBRTranslations from '@shopify/polaris/locales/pt-BR.json';
// import jaTranslations from '@shopify/polaris/locales/ru.json';
import zhCNTranslations from '@shopify/polaris/locales/zh-CN.json';
// import arTranslations from '@shopify/polaris/locales/ar.json';
import daTranslations from '@shopify/polaris/locales/da.json';
import plTranslations from '@shopify/polaris/locales/pl.json';
import svTranslations from '@shopify/polaris/locales/sv.json';
import trTranslations from '@shopify/polaris/locales/tr.json';
// import ukTranslations from '@shopify/polaris/locales/uk.json';
import csTranslations from '@shopify/polaris/locales/cs.json';
// import elTranslations from '@shopify/polaris/locales/el.json';
// import huTranslations from '@shopify/polaris/locales/hu.json';
import koTranslations from '@shopify/polaris/locales/ko.json';
// import noTranslations from '@shopify/polaris/locales/no.json';
// import roTranslations from '@shopify/polaris/locales/ro.json';
import fiTranslations from '@shopify/polaris/locales/fi.json';
// import hiTranslations from '@shopify/polaris/locales/hi.json';
// import hrTranslations from '@shopify/polaris/locales/hr.json';
import thTranslations from '@shopify/polaris/locales/th.json';
import viTranslations from '@shopify/polaris/locales/vi.json';

const PolarisLocale: Record<string, typeof enTranslations> = {
  // XXX: Make sure this is synced with the supported languages in i18n.ts
  en: enTranslations,
  fr: frTranslations,
  de: deTranslations,
  ja: jaTranslations,
  es: esTranslations,
  // id: idTranslations,
  it: itTranslations,
  nl: nlTranslations,
  pt: ptBRTranslations,
  // ru: ruTranslations,
  zh: zhCNTranslations,
  // ar: arTranslations,
  da: daTranslations,
  pl: plTranslations,
  sv: svTranslations,
  tr: trTranslations,
  // uk: ukTranslations,
  cs: csTranslations,
  // el: elTranslations,
  // hu: huTranslations,
  ko: koTranslations,
  // no: noTranslations,
  // ro: roTranslations,
  fi: fiTranslations,
  // hi: hiTranslations,
  // hr: hrTranslations,
  th: thTranslations,
  vi: viTranslations,
};

interface Props {
  children: ReactNode;
}

export default function PolarisProvider({ children }: Props) {
  const [selectedPolarisLocale, setSelectedPolarisLocale] = useState(enTranslations);
  const shopify = useAppBridge();

  useEffect(() => {
    if (shopify?.config?.locale) {
      const locale = shortLangCode(shopify.config.locale);

      // polaris locale
      const polarisLocale = PolarisLocale[locale] || enTranslations; // fallback to en
      setSelectedPolarisLocale(polarisLocale);
    }
  }, [shopify?.config?.locale]);

  return (
    <PolarisAppProvider i18n={selectedPolarisLocale}>
      {children}
    </PolarisAppProvider>
  );
}
